



import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
//import { DeleteBannerImage, DeleteHeaderTypes, GetAllBanner, GetAllHeaderTypes, GetAllLogos, GetAllTenants, deletLogoImages, getAllArea } from '../../../../services/CommonService';
import { Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";

import { GetAllTrainingCourses, GetAllUsersData, commonGet, notifymessages } from '../../../services/CommonService';
import EventBus from '../../../services/EventBus';
import ChangeProgram from './ChangeProgram';
import UserSubscription from './UserSubscription';
import ViewProfile from './ViewProfile';
import moment from "moment";



const EnrolledUsers = () => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [postModal, setPostModal] = useState(false);
    const [modaltype, setModalType] = useState(0);
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    const [data, setData] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [tenantlist, setTenantList] = useState([]);
    const [tenantdata, setTenantData] = useState({});
    const [updateitem, setUpdateItem] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [username, setUserName] = useState(null);
    const [email, setEmail] = useState(null);
    const [mobilenumber, setMobilenumber] = useState(null);
    const [notifymsg, setNotifyMsg] = useState(null);
    const [emailsub, setEmailSub] = useState(null);
    useEffect(() => {
        //getBanner();
        getTenants();
        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");
    }, []);

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
            query: { course: tenantid },
            ptype: 'TRAININGENROLLMENT'
        }



        const respData = await commonGet(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
    }

    const getDatalist = async (tenantid) => {
        let reqparams = null;

        if (tenantid == null) {
            reqparams = {
                pageno: '1'
            }
        } else {
            reqparams = {
                pageno: '1',
                query: { course: tenantid },
                ptype: 'TRAININGENROLLMENT'

            }
        }
        const respData = await commonGet(reqparams);
        console.log(respData);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);

    }

    const getTenants = async () => {
        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' }
        }
        const Response = await GetAllTrainingCourses(reqdata)
        setTenantList(Response.data);
    }

    const openModal = async () => {

        if (tenantid == null) {
            notifyTopFullWidth("Please choose the tenant");
        } else {
            setUpdateItem({});
            setPostModal(true);
        }
    }



    const handleChange = (e) => {
        const { name, value } = e.target;
        setTenantId(value);
        getDatalist(value);

    }
    const closemodal = async () => {

        getDatalist(tenantid);
        setPostModal(false);
    }



    const changepurchaseprogram = async (item) => {
        setModalType(1);
        setUpdateItem(item);
        setPostModal(true);

    }

    const Notify = async () => {
        setPostModal(true);
    }

    const handleChangeNotify = (e) => {
        const { name, value } = e.target;
        setNotifyMsg(value);
    }

    const sendmessage = async (type) => {
        if (tenantid == null) {
            notifyTopFullWidth("Please choose the course to notify");
        }
        const reqData = {
            course: tenantid,
            message: notifymsg,
            reqtype: type,
            subject: emailsub
        }

        const resData = await notifymessages(reqData);
        if(resData.message =='SUCCESS'){
            notifyTopFullWidth(" "+type+" notification successful ");
        }else{
            notifyTopFullWidth("Failed to notify");
        }

    }




    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />

        <Col lg={12}>
            <Card>
                <Card.Header>

                    <Card.Title>Training Enrollments <Button onClick={() => Notify()}
                        className="me-2" variant="primary btn-square"
                        title="Subscribe"
                    >

                        Notify
                    </Button>


                    </Card.Title>
                    <div className="col-lg-3">
                        <select className="form-control" name="tenant"
                            value={tenantid} onChange={handleChange}>
                            <option value=''>Select Tenant</option>
                            {tenantlist.map(item => (
                                <option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>




                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>

                                <th>
                                    <strong>User Name</strong>
                                </th>
                                <th>
                                    <strong>Email</strong>
                                </th>
                                <th>
                                    <strong>Mobile Number</strong>
                                </th>
                                <th>
                                    <strong>Mode of Training</strong>
                                </th>

                                <th>
                                    <strong>Education</strong>
                                </th>

                                <th>
                                    <strong>College</strong>
                                </th>

                                <th>
                                    <strong>Semister</strong>
                                </th>
                                <th>
                                    <strong>Type</strong>
                                </th>
                                <th>
                                    <strong>Created Date</strong>
                                </th>



                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(item => (
                                <tr>
                                    <td>
                                        <strong>{item.name}</strong>
                                    </td>
                                    <td>{item.email}</td>
                                    <td>{item.mobilenumber}</td>
                                    <td>{item.modeoftraining}</td>
                                    <td>{item.education}</td>
                                    <td>{item.college}</td>
                                    <td>{item.semister}</td>
                                    <td>{item.modetype}</td>
                                    <td>{moment(item.createddate).format('YYYY-MM-DD h:mm:ss a')}</td>

                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="light sharp i-false"
                                            >
                                                {svg1}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => changepurchaseprogram(item)}>
                                                    Notify User

                                                </Dropdown.Item >



                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>
            </Card>
        </Col>

        <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
            <div className="" role="document">
                <div className="">
                    <form >
                        <div className="modal-header">

                            <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">

                            <textarea rows={8} className="form-control"
                                name="notifymsg" placeholder=""
                                defaultValue={""}
                                onChange={handleChangeNotify}
                                value={notifymsg}
                            />

                            <div className="col-lg-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="email" className="text-black font-w600"> Email Subject </label>
                                    <input type="text" className="form-control"
                                     defaultValue="" placeholder="Email Subject" name="emailsub"  value ={emailsub}
                                     onChange={(e)=>setEmailSub(e.target.value)}/>
                                </div>
                            </div>

                        </div>
                        {<div className="modal-footer">
                            <button type="submit" className="btn btn-primary"  onClick={()=>sendmessage('SMS')}>Send SMS</button>
                            <button type="button" onClick={()=>sendmessage('EMAIL')} className="btn btn-danger">
                                Send Email</button>
                            <button type="button" onClick={()=>sendmessage('PUSH')} className="btn btn-warning">
                                Push Notification</button>
                        </div>}
                    </form>

                </div>
            </div>
        </Modal>

    </>)
}
export default EnrolledUsers;